export enum ChangeRequestStatus {
  PENDING = 1,
  APPROVED,
  REJECTED,
  CANCELLED,
  APPLIED,
}

export enum ContractStatus {
  // Arquivo do contrato enviado, mas a formalização ainda não foi submetida
  // pelo credenciado — o banco não tem o que analisar ainda. Vem de
  // `_derive_contract_status` no backend.
  AWAITING_SUBMISSION = 'awaiting_submission',
  IN_ANALYSIS = 'in_analysis',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export const convertContractStatus = (docStatus: ContractStatus): string => {
  let word: string;
  switch (docStatus) {
    case ContractStatus.AWAITING_SUBMISSION:
      word = 'aguardando envio';
      break;
    case ContractStatus.IN_ANALYSIS:
      word = 'em análise';
      break;
    case ContractStatus.APPROVED:
      word = 'aprovado';
      break;
    case ContractStatus.REJECTED:
      word = 'rejeitado';
      break;
    default:
      word = '';
  }
  return word;
};

export enum TermKind {
  ADDITION = 'addition',
  DISCHARGE = 'discharge',
  SCOPE_ADDITION = 'scope_addition',
  SCOPE_REMOVAL = 'scope_removal',
}

export enum ScopeTermKind {
  POLES = 'poles',
  TYPOLOGY_GROUPS = 'typology_groups',
}

export enum TermState {
  NOT_REQUIRED = 'not_required',
  AWAITING_DOCUMENTS = 'awaiting_documents',
  AWAITING_SIGNATURE = 'awaiting_signature',
  AWAITING_REVIEW = 'awaiting_review',
  APPROVED = 'approved',
  CANCELLED = 'cancelled',
}

export enum NoticeCompanyType {
  SELECT = 0,
  INDIVIDUAL = 1,
  LIMITED_SOCIETY = 2,
  LIMITED_UNIPERSONAL_SOCIETY = 3,
  ANONYMOUS = 4,
  SIMPLE_SOCIETY = 5,
  COOPERATIVE = 6,
  EIRELI = 7,
}

export const convertNoticeCompanyType = (
  enumType: NoticeCompanyType
): string => {
  let word: string;
  switch (enumType) {
    case NoticeCompanyType.SELECT:
      word = 'selecione uma opção';
      break;
    case NoticeCompanyType.INDIVIDUAL:
      word = 'Empresário Individual (EI)';
      break;
    case NoticeCompanyType.LIMITED_SOCIETY:
      word = 'Sociedade limitada (LTDA)';
      break;
    case NoticeCompanyType.LIMITED_UNIPERSONAL_SOCIETY:
      word = 'Sociedade limitada unipessoal (SLU)';
      break;
    case NoticeCompanyType.ANONYMOUS:
      word = 'Sociedade anônima (S.A.)';
      break;
    case NoticeCompanyType.SIMPLE_SOCIETY:
      word = 'Sociedade simples';
      break;
    case NoticeCompanyType.COOPERATIVE:
      word = 'Cooperativa';
      break;
    case NoticeCompanyType.EIRELI:
      word = 'EIRELI (resquícios antigos)';
      break;
    default:
      word = '';
  }
  return word;
};

export enum NoticeCompanyUserStatus {
  DRAFT = 'draft',
  PENDING = 'pending',
  APPROVED = 'approved',
  PAUSED = 'paused',
  REJECTED = 'rejected',
  CANCELLED = 'cancelled',
  DISCREDITED = 'discredited',
  LEAVING = 'leaving',
}

export const convertNoticeCompanyUserStatus = (
  status: NoticeCompanyUserStatus
): string => {
  let word: string;
  switch (status) {
    case NoticeCompanyUserStatus.DRAFT:
      word = 'rascunho';
      break;
    case NoticeCompanyUserStatus.PENDING:
      word = 'em análise';
      break;
    case NoticeCompanyUserStatus.APPROVED:
      word = 'disponível';
      break;
    case NoticeCompanyUserStatus.PAUSED:
      word = 'pausado';
      break;
    case NoticeCompanyUserStatus.REJECTED:
      word = 'não aprovado';
      break;
    case NoticeCompanyUserStatus.CANCELLED:
      word = 'cancelado';
      break;
    case NoticeCompanyUserStatus.DISCREDITED:
      word = 'descredenciado';
      break;
    case NoticeCompanyUserStatus.LEAVING:
      word = 'saindo';
      break;
    default:
      word = '';
  }
  return word;
};

export enum ChangeRequestType {
  ADD_COVERAGE = 1,
  ADD_CRITERIA,
  REMOVE_COVERAGE,
  REMOVE_CRITERIA,
  WITHDRAW_WAITLIST,
  ACCEPT_WAITLIST_OFFER,
}
